import { Observable } from 'rxjs';

import Paginate from '../interfaces/paginate';
import Role from '../interfaces/role';
import { HttpClient } from './http-client';

export class RoleService extends HttpClient {
  all(): Observable<Role[]> {
    return this.get<Role[]>('/api/internal/roles/all');
  }

  index(
    page: number = 1,
    sort?: string,
    desc: boolean = false
  ): Observable<Paginate<Role>> {
    return this.get<Paginate<Role>>('/api/internal/roles', {
      page,
      sort,
      desc,
    });
  }

  show(id: string): Observable<Role> {
    return this.get<Role>(`/api/internal/roles/${id}`);
  }

  store(role: Role): Observable<Role> {
    return this.post<Role>(`/api/internal/roles`, role);
  }

  update(id: string, role: Role): Observable<Role> {
    return this.put<Role>(`/api/internal/roles/${id}`, role);
  }

  destroy(id: string) {
    return this.delete(`/api/internal/roles/${id}`);
  }
}
